"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorStates = exports.runnableKinds = exports.contentTypeHeader = exports.authorizationHeader = exports.applicationJsonType = void 0;
exports.applicationJsonType = "application/json";
exports.authorizationHeader = "Authorization";
exports.contentTypeHeader = "Content-Type";
exports.runnableKinds = ["pipeline", "connection"];
exports.errorStates = ["FAILED", "RETRYING"];
